import React, { useState } from "react";
import { eyeOpen, eyeClose } from "../assets";

const Input = ({
  type,
  id,
  req,
  onBlurfunc,
  onChangefunc,
  value,
  error,
  showIcon,
  stateIcon,
  setStateIcon,
}) => {
  return (
    <div className="flex flex-col">
      <label className="text-[14px] capitalize mb-1">
        {id}
        {req ? <span className="text-red-500">*</span> : ""}
      </label>
      <div
        className={`flex flex-row rounded-md shadow-sm border focus-within:border-primary ${
          !error ? `border-red-400` : ``
        }`}
      >
        <input
          className={`flex flex-col pl-2 py-2 md:pl-[14px] md:py-[10px] text-[14px] leading-tight focus:outline-none rounded-md bg-transparent first-letter:focus:shadow-outline justify-between ${
            showIcon ? "w-[85%]" : "w-full"
          }`}
          id={id}
          type={type}
          placeholder={"Your " + id}
          onBlur={onBlurfunc}
          onChange={onChangefunc}
          value={value}
        />
        {showIcon ? (
          <div className="flex flex-col justify-center items-center w-[15%]">
            <img
              src={stateIcon ? eyeOpen : eyeClose}
              className="w-4 cursor-pointer"
              onClick={(e) => setStateIcon(!stateIcon)}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Input;
